/* eslint-disable no-param-reassign */

export function background (el, { value, oldValue }) {
  if (value && (!oldValue || oldValue !== value)) {
    el.style.backgroundImage = `url(${value})`;
  }

  el.style.backgroundSize = 'cover';
  el.style.backgroundPosition = 'center';
}
